import { TIconField, TImageField, TStringField } from '../../../types/sitecore.types';
import { TSitecoreContext } from '../../../types/types';
import { TBrochureCardField, TDownloadBrochureFields, TDownloadBrochuresProps } from '../types/downloadBrochures.types';

export class ProductDownloadBrochureModel {
  private readonly fields: TDownloadBrochureFields;
  private readonly context: TSitecoreContext;

  constructor(props: TDownloadBrochuresProps) {
    this.context = props.sitecoreContext;
    this.fields = props.fields;
  }

  get title(): TStringField | undefined {
    return this.fields?.title;
  }

  get eyebrow(): TStringField | undefined {
    return this.fields?.eyebrow;
  }

  get subtitle(): TStringField | undefined {
    return this.fields?.subHeading;
  }

  get shareIcon(): TIconField | undefined {
    return this.fields?.shareIcon;
  }

  get downloadIcon(): TIconField | undefined {
    return this.fields?.downloadIcon;
  }

  get viewIcon(): TIconField | undefined {
    return this.fields?.viewIcon;
  }

  get brochureCards(): TBrochureCardField[] {
    return this.fields?.items || [];
  }
  get backgroundImage(): TImageField | undefined {
    return this.fields?.image;
  }

  get backgroundImageMobile(): TImageField | undefined {
    return this.fields?.mobileImage;
  }

  get currentPageUrl(): string {
    return this.context?.currentPageUrl ?? '';
  }
  get desktopBgImage(): TImageField | undefined {
    return this.backgroundImage?.value?.src ? this.backgroundImage : this.defaultBgDesktopImage;
  }

  get mobileBgImage(): TImageField | undefined {
    return this.backgroundImageMobile?.value?.src ? this.backgroundImageMobile : this.defaultBgMobileImage;
  }
  get defaultBgDesktopImage(): TImageField | undefined {
    return {
      value: {
        src: this.context?.defaultBackgroundImageParameters?.desktopImageData?.downloadBrochures,
      },
    };
  }

  get defaultBgMobileImage(): TImageField | undefined {
    return {
      value: {
        src: this.context?.defaultBackgroundImageParameters?.mobileImageData?.downloadBrochures,
      },
    };
  }
}
